import React from "react";
import PolicyLayout, { PolicySection } from "./PolicyLayout";

const ShippingPolicy = () => (
  <PolicyLayout eyebrow="Policies" title="Shipping & Delivery" updated="August 2026">
    <p className="text-lg">Every piece we make is crafted to order in our Ahmedabad studio. Please read our timelines carefully before you place an order.</p>

    <PolicySection title="Where we ship">
      <p>We currently ship anywhere within India. For international shipping, please write to us at <a href="mailto:venus3dcreations@gmail.com" className="text-[var(--copper)] vc-link-underline">venus3dcreations@gmail.com</a> before ordering and we’ll share a custom quote.</p>
    </PolicySection>

    <PolicySection title="Processing time (before your order ships)">
      <p>Most lamps and standard pieces are shipped within <strong>3–5 business days</strong> from the day payment is received. Custom or larger pieces may take up to <strong>10 business days</strong>.</p>
      <p>If a particular piece needs additional time, we will communicate the revised timeline with you directly before dispatch.</p>
    </PolicySection>

    <PolicySection title="Delivery time (after your order ships)">
      <p>Once dispatched, delivery typically takes <strong>5–7 business days</strong> across India. All shipments are handled by our logistics partners (Shiprocket, Delhivery, BlueDart and similar) and you will receive an email with the courier name and tracking link once your AWB is generated.</p>
    </PolicySection>

    <PolicySection title="Shipping charges">
      <p><strong>Complimentary shipping on all orders above ₹2,500</strong>, anywhere in India.</p>
      <p>Below that, shipping is calculated live at checkout based on your delivery pincode, package weight and courier partner (a flat ₹99 applies where live rates are unavailable). The exact amount is always shown before you confirm your payment.</p>
    </PolicySection>

    <PolicySection title="Packaging">
      <p>Every Venus piece is packed with care — cushioned padding, secure inserts and eco-friendly outer packaging. We do our best to keep waste minimal without compromising on the piece arriving in perfect condition.</p>
    </PolicySection>

    <PolicySection title="Delayed or failed deliveries">
      <p>If a shipment is delayed by more than 3 business days beyond the estimate, or if it’s marked “undelivered” by the courier, please email us and we’ll investigate immediately. In most cases we can arrange a re-attempt within 24 hours.</p>
    </PolicySection>

    <PolicySection title="Order cancellation">
      <p>You can cancel or modify your order within <strong>12 hours</strong> of placing it — email us at <a href="mailto:venus3dcreations@gmail.com" className="text-[var(--copper)] vc-link-underline">venus3dcreations@gmail.com</a> with your order number and we'll refund you in full.</p>
      <p>After 12 hours, production has begun and orders can no longer be cancelled. If you receive a piece that is damaged or defective, please refer to our <a href="/policies/refunds" className="text-[var(--copper)] vc-link-underline">Refunds & Returns policy</a>.</p>
    </PolicySection>

    <PolicySection title="Questions">
      <p>Reach us any time at <a href="mailto:venus3dcreations@gmail.com" className="text-[var(--copper)] vc-link-underline">venus3dcreations@gmail.com</a> or <a href="tel:+918849440828" className="text-[var(--copper)] vc-link-underline">+91 88494 40828</a>. We reply within 48 hours.</p>
    </PolicySection>
  </PolicyLayout>
);

export default ShippingPolicy;
